import { FC } from 'react';
import { ActionIcon, Group, Text } from '@mantine/core';
import { IconDownload, IconPaperclip } from '@tabler/icons';
import { ImapAttachmentDTO } from '../../Types/MailT';
import { FileS } from '../../Service/FileS';
import { openFileViewModal } from '../../Molecules/Dialogs/FileViewModal';

const ImapAttachment: FC<{ file: ImapAttachmentDTO }> = ({ file }) => {
  const { byteArray, fileName, contentType } = file;

  const download = () => {
    const blob = FileS.base64ToBlob(byteArray);
    FileS.download(fileName, blob);
  };

  const showPreview = () => {
    const file = FileS.base64ToBlob(byteArray);
    openFileViewModal({ fileName, file, contentType });
  };

  return (
    <Group
      my="md"
      position="apart"
      p="xs"
      sx={(theme) => ({
        borderRadius: theme.radius.sm,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
        maxWidth: 250,
      })}
    >
      <Text
        weight="bold"
        lineClamp={1}
        sx={(theme) => ({
          cursor: 'pointer',
          color: theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[4],
        })}
        variant="link"
        onClick={showPreview}
      >
        <IconPaperclip size={16} style={{ marginRight: 5 }} />
        {fileName}
      </Text>
      <ActionIcon size="xs" onClick={download}>
        <IconDownload />
      </ActionIcon>
    </Group>
  );
};

export default ImapAttachment;
